import { useMemo } from 'react';

import { useEventsQuery, useWeddingWebsiteQuery } from '../generated/graphql';

export const useRsvpIsVisible = (): boolean => {
  const { data } = useEventsQuery();
  const { data: wwData } = useWeddingWebsiteQuery();

  // Legacy way to check if RSVP should be shown
  const anyEventsRsvpOn =
    useMemo(() => data?.events.filter(e => e.type !== 'Reception').some(e => e.requireRsvp), [data]) || false;

  return anyEventsRsvpOn && !wwData?.guestWedding?.rsvpPageHidden;
};
